import { connect } from 'react-redux'
import ViewerApp from '../components/ViewerApp'
import { LOADING_PAGE_VIEW, selectBaseMap } from '../actions/viewmode'
import { initializeViewer, initializeGlobalLayers, initializeViewerGeometries } from '../actions/initialization'
import { REQUEST_GEOMETRIES } from '../actions/fields'
import { areRequestsSuccessful } from '@layers-frontend/commons/store/selectors/requests'
import '../utils'

import { getEOXXML, getConfigProjection, getIsAppReady, isViewerReady, isMapReady, isMapZoomReady } from '../selectors/config'
import { getSelectedBaseMap, getScreenView, getSelectedBaseMapIndex } from '../selectors/viewmode'
import { getLocale, getMessages } from '../selectors/i18n'
import { getUser } from '../selectors/users'
import { isUIRequestViewerDataInitializationSuccess, getZoomLevel } from '../selectors/ui'

const mapStateToProps = (state, props) => {
  return {
    /** projection of the map **/
    projection: getConfigProjection(state),
    baseMap: getSelectedBaseMap(state),
    isTutorial: state.tutorial.isOpen,
    isLoading: getScreenView(state) === LOADING_PAGE_VIEW,
    locale: getLocale(state),
    messages: getMessages(state),
    user: getUser(state),
    isViewerDataLoaded: isUIRequestViewerDataInitializationSuccess(state),
    isAppReady: getIsAppReady(state),
    eoxXML: getEOXXML(state),
    view: getScreenView(state),
    zoomLevel: getZoomLevel(state),
    baseMapsSelectedIndex: getSelectedBaseMapIndex(state),
    isViewerReady: isViewerReady(state),
    isMapReady: isMapReady(state),
    isMapZoomReady: isMapZoomReady(state),
    isGeometriesLoaded: areRequestsSuccessful(state, [REQUEST_GEOMETRIES])
  }
}

const mapDispatchToProps = {
  initializeViewer,
  selectBaseMap,
  initializeGlobalLayers,
  initializeViewerGeometries
}

export default connect(mapStateToProps, mapDispatchToProps)(ViewerApp)
